import React from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaExclamationTriangle, FaCheckCircle, FaFileAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const TerminationModes = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.5 }
  };

  return (
    <div style={{
      minHeight: '100vh',
      paddingTop: '2rem',
      paddingBottom: '4rem',
      width: '100%'
    }}>
      <Container>
        {/* HEADER */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-5"
        >
          <h1 className="text-white fw-bold mb-3">
            Tryby rozwiązania umów
          </h1>
          <p className="text-white-50" style={{ fontSize: '1.2rem' }}>
            Rozwiązanie umowy o naukę zawodu
          </p>
        </motion.div>

        <Row className="justify-content-center">
          <Col xs={12} lg={10}>
            {/* INTRO CARD */}
            <motion.div
              {...fadeInUp}
              className="mb-4"
            >
              <Card className="border-0 shadow-lg" style={{ 
                borderRadius: '20px',
                background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(0, 86, 179, 0.1) 100%)'
              }}>
                <Card.Body className="p-4">
                  <p className="mb-3" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                    <strong>Umowę o pracę w celu przygotowania zawodowego możesz rozwiązać w każdym momencie 
                    trwania umowy.</strong> Za zerwanie umowy nie grożą Ci żadne konsekwencje, bo nie jest to 
                    umowa niewolnicza.
                  </p>
                  <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                    Jednak zbyt częste zmienianie pracodawcy i miejsca praktyk skutkuje brakiem wiarygodności, 
                    że tym razem zostaniesz na dłużej. Bardzo trudna jest zmiana praktyk w klasie 3.
                  </p>
                </Card.Body>
              </Card>
            </motion.div>

            {/* WHEN TO CHANGE */}
            <motion.div
              {...fadeInUp}
              transition={{ delay: 0.1 }}
              className="mb-4"
            >
              <Card
                className="border-0 shadow-lg"
                style={{
                  borderRadius: '20px',
                  background: 'rgba(220, 53, 69, 0.1)',
                  border: '2px solid rgba(220, 53, 69, 0.3)'
                }}
              >
                <Card.Body className="p-4">
                  <h5 className="fw-bold mb-3">
                    <FaExclamationTriangle className="me-2" style={{ color: '#dc3545' }} />
                    Jeżeli jednak:
                  </h5>
                  <ul className="mb-3" style={{ fontSize: '1rem', lineHeight: '1.8' }}>
                    <li>stosowany jest wobec Ciebie <strong>mobbing</strong></li>
                    <li>wykonujesz <strong>prace niezwiązane z nauką zawodu</strong></li>
                    <li>otrzymujesz <strong>zbyt niskie wynagrodzenie</strong></li>
                    <li>przymuszają Cię do <strong>łamania prawa i przychodzenia w soboty</strong></li>
                  </ul>
                  <p className="mb-0 fw-bold text-center" style={{ fontSize: '1.2rem', color: '#dc3545' }}>
                    POMYŚL O ZMIANIE
                  </p>
                </Card.Body>
              </Card>
            </motion.div>

            {/* HOW TO DO IT */}
            <motion.div
              {...fadeInUp}
              transition={{ delay: 0.2 }}
              className="mb-4"
            >
              <Card className="border-0 shadow-lg" style={{ 
                borderRadius: '20px',
                background: 'rgba(255,255,255,0.03)',
                border: '2px solid rgba(255,255,255,0.2)'
              }}>
                <Card.Body className="p-4">
                  <h5 className="fw-bold mb-4 text-white">
                    <FaCheckCircle className="me-2" style={{ color: '#43e97b' }} />
                    Jak to zrobić?
                  </h5>

                  <div className="mb-3 p-3 rounded" style={{
                    background: 'rgba(102, 126, 234, 0.1)',
                    borderLeft: '4px solid #667eea'
                  }}>
                    <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                      <strong>1.</strong> Najpierw, zanim zrezygnujesz, <strong>znajdź nowego pracodawcę</strong>, 
                      który przyjmie Cię na naukę zawodu
                    </p>
                  </div>

                  <div className="mb-3 p-3 rounded" style={{
                    background: 'rgba(102, 126, 234, 0.1)',
                    borderLeft: '4px solid #667eea'
                  }}>
                    <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                      <strong>2.</strong> Zgłoś obecnemu pracodawcy, że chcesz rozwiązać umowę o naukę zawodu. 
                      Najlepiej zrobić to z <strong>rodzicami</strong>, bo oni też są stroną umowy. Najlepiej też 
                      <strong> nie podawać nazwę nowego pracodawcy</strong>, z którym masz domówione nowe praktyki.
                    </p>
                  </div>

                  <div className="mb-3 p-3 rounded" style={{
                    background: 'rgba(102, 126, 234, 0.1)',
                    borderLeft: '4px solid #667eea'
                  }}>
                    <p className="mb-2" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                      <strong>3.</strong> Dowiedz się jaka forma rozwiązania umowy będzie zaakceptowana. 
                      Masz 2 opcje:
                    </p>
                    <ul className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                      <li className="mb-2">
                        <strong>a. za porozumieniem stron</strong> (ta opcja jest najlepsza, bo odbywa się 
                        natychmiast, ale nie zawsze pracodawca wyraża na nią zgodę)
                      </li>
                      <li>
                        <strong>b. z zachowaniem terminu wypowiedzenia</strong> (to opcja mniej korzystna, 
                        ale jedyna jeżeli pracodawca nie wyrazi zgody na punkt a)
                      </li>
                    </ul>
                  </div>

                  <div className="mb-3 p-3 rounded" style={{
                    background: 'rgba(102, 126, 234, 0.1)',
                    borderLeft: '4px solid #667eea'
                  }}>
                    <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                      <strong>4.</strong> Po ustaniu stosunku pracy u „starego" pracodawcy musisz przejść do 
                      nowego miejsca praktyk ze <strong>świadectwem pracy</strong>, które jest podstawą nowej 
                      umowy o naukę zawodu, tak aby w sumie po dodaniu obu świadectw uzyskać 36 miesięcy nauki zawodu.
                    </p>
                  </div>

                  <div className="p-3 rounded" style={{
                    background: 'rgba(102, 126, 234, 0.1)',
                    borderLeft: '4px solid #667eea'
                  }}>
                    <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                      <strong>5.</strong> Świadectwo pracy wystawia pracodawca w ciągu <strong>7 dni</strong> od 
                      rozwiązania umowy. Może je wręczyć osobiście, a może wysłać pocztą listem poleconym.
                    </p>
                  </div>
                </Card.Body>
              </Card>
            </motion.div>

            {/* DOCUMENTS LINK */}
            <motion.div
              {...fadeInUp}
              transition={{ delay: 0.5 }}
            >
              <Card
                className="border-0 shadow-lg"
                style={{
                  borderRadius: '20px',
                  background: 'linear-gradient(135deg, rgba(67, 233, 123, 0.15) 0%, rgba(64, 224, 208, 0.15) 100%)',
                  border: '2px solid rgba(67, 233, 123, 0.3)'
                }}
              >
                <Card.Body className="p-4 text-center">
                  <FaFileAlt className="mb-3" style={{ fontSize: '3rem', color: '#43e97b' }} />
                  <h5 className="fw-bold mb-3">Potrzebujesz wzorów dokumentów?</h5>
                  <p className="mb-3" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                    Wzory rozwiązania umowy za porozumieniem stron oraz z zachowaniem okresu wypowiedzenia 
                    znajdziesz w zakładce Wzory Dokumentów.
                  </p>
                  <Link 
                    to="/documents" 
                    className="btn btn-lg"
                    style={{
                      background: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
                      border: 'none',
                      color: 'white',
                      fontWeight: 'bold',
                      padding: '12px 40px',
                      borderRadius: '50px',
                      boxShadow: '0 4px 15px rgba(67, 233, 123, 0.3)',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 6px 20px rgba(67, 233, 123, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(67, 233, 123, 0.3)';
                    }}
                  >
                    <FaFileAlt className="me-2" />
                    Przejdź do Wzorów Dokumentów
                  </Link>
                </Card.Body>
              </Card>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TerminationModes;